import { render, staticRenderFns } from "./Allegati.vue?vue&type=template&id=0b2ab622&scoped=true&"
import script from "./Allegati.vue?vue&type=script&lang=js&"
export * from "./Allegati.vue?vue&type=script&lang=js&"
import style0 from "./Allegati.vue?vue&type=style&index=0&id=0b2ab622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ab622",
  null
  
)

export default component.exports